import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import truck1 from "../../../assets/img/esg/esgFour/truck1.webp";
import truck2 from "../../../assets/img/esg/esgFour/truck2.webp";
import truck3 from "../../../assets/img/esg/esgFour/truck3.webp";
import truck4 from "../../../assets/img/esg/esgFour/truck4.webp";
import plvb from "../../../assets/img/esg/esgFour/DOW_logo_Membro_Ouro 1.webp";
import arrowLeft from "../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../assets/img/components/arrow-right.webp";

import 'swiper/css';
import 'swiper/css/navigation';

function EsgFour(){
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const data = [
      {
          id: 1,
          title: t("esg_four_card1_title"),
          class: "card2",
          content: t("esg_four_card1_text"),
          imageUrl: truck2,
      },
      {
          id: 2,
          title: t("esg_four_card2_title"),
          class: "card3",
          content: t("esg_four_card2_text"),
          imageUrl: truck3,
      },
      {
        id: 3,
        title: t("esg_four_card3_title"),
        class: "card4",
        content: t("esg_four_card3_text"),
        imageUrl: truck4,
      }
    ];
    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
        <div id="esgFour" className={`esgFour ${isVisible ? 'visible' : ''}`}>
          <div className="esgFourTitle">
            <h1 className={`${isVisible ? 'visible' : ''}`}><span>{t("esg_four_title_span")}</span> {t("esg_four_title")}</h1>
            <p className={`${isVisible ? 'visible' : ''}`}>
              {t("esg_four_text")}
            </p>
          </div>
          <Swiper
            className={`${isVisible ? 'visible' : ''}`} 
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }}
            modules={[Navigation]} 
            /* breakpoints={breakpoints} */
            slidesPerView={'1'}
            spaceBetween={200}
            speed={800}
            >
            <div className={`swiper-button-prev ${isVisible ? 'visible' : ''}`}><img src={arrowLeft} width={'40px'} alt="" /></div>
              {
                data.map( (item) => (
                  <SwiperSlide key={item.id}>
                    <div className={`card ${item.class}`}>
                      <div className="cardText">
                        <h3 className={`${isVisible ? 'visible' : ''}`}>{item.title}</h3>
                        <h4 className={`${isVisible ? 'visible' : ''}`}>{item.subtitle}</h4>
                        <p className={`${isVisible ? 'visible' : ''}`}>{item.content}</p>
                      </div>
                      <div className="cardImg">
                        <img src={plvb} className={`plvb ${isVisible ? 'visible' : ''}`} alt="" width={'150px'}/>
                        <img className={`${isVisible ? 'visible' : ''}`} src={item.imageUrl} alt="" width={'700px'}/>
                      </div>
                    </div>
                  </SwiperSlide>
                ))
              }
            <div className={`swiper-button-next ${isVisible ? 'visible' : ''}`}><img src={arrowRight} width={'40px'} alt="" /></div>
          </Swiper>
        </div>
        </VisibilitySensor>
    )
}

export default EsgFour;